import React from 'react'

import ApiUtils from "../../api/ApiUtils"

import BotSimpleMessage from './BotSimpleMessage'

import SearchResultLuce from '../results/SearchResultLuce'

import { MzInputText } from '../../components'

import { Button } from 'primereact/button'

import UserMessage from '../UserMessage'

import func from '../utils/Functions'



const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;


export default function InnerSearchResultLuce({ message, isLastBotMessage,  setIsTyping, messages, setMessages, answers,setAnswers,urlBotImage }) {
    const [loading, setLoading] = React.useState(false);
    const [buttonDisabled, setButtonDisabled] = React.useState(!isLastBotMessage);
    const [inputValue, setInputValue] = React.useState(message.inputValue || "");
    const [isCompanySelected, setIsCompanySelected] = React.useState(message.isCompanySelected||false);


    const onCompanySelected = async (leadId, offertaId) => {
        //  alert( `Per il lead num ${leadId} hai cliccato su offerta ${offertaId}`)
        let body = {
            "offerta_id": offertaId
        }

        let resp = await ApiUtils.post(`tariff_comparator/v1/ans/l/${leadId}`, body);

        if (resp.status === 200) {
            await window.Swal.fire({
                title: 'Tutto ok!',
                icon: 'success',
                confirmButtonText: 'Ora puoi parlare di qualsiasi offerta con la nostra IA!'

            })
            setIsCompanySelected(true)
        }
    }



    const onStartChat = async () => {
        console.log("Button clicked with input:", inputValue);
        let domanda = inputValue;
        let offerte = message.results.map((result) => result.id);

        let body = {
            "o": offerte,
            "msg": domanda
        };

        setLoading(true);
        let resp = await ApiUtils.post("tariff_comparator/v1/chat/s/l", body);

        let chatMsg = {
            "id": resp.data.id,
            "tipo": "chat",
            "sender": "bot",
            "testo": resp.data.answer,
            "payload": resp.data.payload
        };
        func.addMetaInfo(chatMsg);
        console.log("New message added:", chatMsg);

        // Aggiorna il messaggio corrente con il valore dell'input
        const updatedMessages = messages.map((msg) => {
            if (msg.id === message.id) {
                return { ...msg, inputValue: inputValue , isCompanySelected:true};
            }
            return msg;
        });

        setMessages([...updatedMessages, chatMsg]);
        setLoading(false);
        setButtonDisabled(true);
    };

    const handleChange = (e) => {
        console.log("Input changed:", e.target.value);
        setInputValue(e.target.value);
    };

    return (
        <div key={"lll_" + message.id}>
            <BotSimpleMessage key={"bot1_" + message.id} urlBotImage={urlBotImage} message={message} isLastBotMessage={isLastBotMessage} setMessages={setMessages} setIsTyping={setIsTyping} messages={messages} />
            <div key={"bot2_" + message.id} className='grid'>
                <div key={"EXT" + message.id} className='col-11 col-offset-1 pl-3'>
                    {message.results.map((result, index) => (
                        <div key={`${result.id}_${index}`}>
                            <SearchResultLuce onCompanySelected={onCompanySelected} result={result} leadId={message.leadId} index={index}></SearchResultLuce>
                        </div>
                    ))}
                </div>
            </div>

            {isCompanySelected && (
                buttonDisabled == false ? (
                    <>
                    <div className='flex justify-content-center'>   
                        <img alt="logo" src={IMAGE_URL + "/logoAI.png"} className="parla_ia  align-self-center"></img>
                    </div>

                    <div className="grid">
                        <div className='col-9 col-offset-1'>
                            <MzInputText
                                placeholder={"Se hai domande scrivi pure"}
                                className={"ml-2"}
                                id={"input_" + message.id}
                                stateValue={inputValue}
                                setStateValue={setInputValue}
                                disabled={buttonDisabled}
                            />
                        </div>
                        <div className='col-2 '>
                            <Button loading={loading} disabled={buttonDisabled} onClick={onStartChat} className='ml-2' label={loading ? "" : ">"} />
                        </div>
                    </div>
                    </>
                ) : 
                    <UserMessage msg={message}></UserMessage>
            )}

        </div>
    );
}